// "Reloj" de la cadena a partir de la última respuesta real de get_info.
// La cadena produce un bloque cada 500 ms, así que entre consultas se puede
// saber el head, el LIB, su hora y (con el schedule) quién lo firma sin pedir
// nada más a la API.
import { parseChainTime } from './chainTime';
import { turnAt } from './schedule';

const BLOCK_MS = 500;

/**
 * info = respuesta de get_info + fetchedAt (Date.now() al recibirla)
 * → { headNum, lib, headTime (ms) } estimados en `now`, o null
 */
export const estimateHead = (info, now = Date.now()) => {
  if (!info || info.fetchedAt == null) return null;
  const elapsed = Math.max(0, Math.floor((now - info.fetchedAt) / BLOCK_MS));
  const headTime = parseChainTime(info.head_block_time)?.getTime();
  return {
    headNum: info.head_block_num + elapsed,
    lib: info.last_irreversible_block_num + elapsed,
    headTime: headTime != null ? headTime + elapsed * BLOCK_MS : null
  };
};

// Cuánto va la API por detrás del reloj (ms) según esa respuesta
export const apiLag = (info) => {
  const headTime = parseChainTime(info?.head_block_time)?.getTime();
  return info?.fetchedAt != null && headTime != null ? Math.max(0, info.fetchedAt - headTime) : null;
};

/**
 * Últimos `count` bloques calculados: número, productor (por el schedule y la
 * hora del bloque), posición en su turno y hora equivalente en el reloj local.
 * Sin schedule solo se conoce el productor del head real.
 */
export const recentBlocks = (info, active, now = Date.now(), count = 8) => {
  const est = estimateHead(info, now);
  if (!est || est.headTime == null) return [];
  const lag = apiLag(info) || 0;
  const n = active?.length || 0;
  return Array.from({ length: count }, (_, i) => {
    const time = est.headTime - i * BLOCK_MS;
    const turn = n ? turnAt(n, time) : null;
    return {
      num: est.headNum - i,
      producer: turn ? active[turn.index] : (i === 0 ? info.head_block_producer : null),
      blockInTurn: turn ? turn.block : null,
      timestamp: new Date(time + lag) // misma referencia que "x secs ago" del resto de la página
    };
  });
};

// Productor del head estimado (cae al real si no hay schedule)
export const currentProducerAt = (info, active, now = Date.now()) => {
  const est = estimateHead(info, now);
  if (!est || est.headTime == null || !active?.length) return info?.head_block_producer || '';
  return active[turnAt(active.length, est.headTime).index];
};
